import InsightItem from 'components/InsightItem';
import SegmentedBar from 'components/SegmentedBar';
import { useAtomValue } from 'jotai';
import React from 'react';
import { Card } from 'reactstrap';

import { assetInsightsAtom } from './state';

const AssetInsights: React.FC = () => {
  const assetInsightsData = useAtomValue(assetInsightsAtom);
  const insights = assetInsightsData?.insights;
  const isLoading = assetInsightsData?.loading;

  // Use zero values when loading to show placeholder UI
  const stats = {
    total: isLoading ? 0 : insights?.total || 0,
    totalFailedPostures: isLoading ? 0 : insights?.total_failed_postures || 0,
    totalPassedPostures: isLoading ? 0 : insights?.total_passed_postures || 0,
    uniqueOsCount: isLoading ? 0 : insights?.unique_os_count || 0,
    uniquePolicyCount: isLoading ? 0 : insights?.unique_policy_count || 0,
  };

  return (
    <div className="container-fluid border border-light rounded p-0 mb-1">
      <Card
        className="mb-0 px-3 py-1"
        style={{ backgroundColor: 'rgba(34, 42, 66, 0.02)' }}
      >
        <div className="d-flex flex-wrap align-items-center">
          <div
            className="mr-2 pr-2 flex-grow-1 border-right"
            style={{ borderColor: '#dee2e6' }}
          >
            <h6 className="mb-0">Compliance Status:</h6>
            <SegmentedBar
              height="5px"
              width="100%"
              segments={[
                {
                  color: 'fail',
                  value: stats.totalFailedPostures,
                  label: 'Failed',
                },
                {
                  color: 'pass',
                  value: stats.totalPassedPostures,
                  label: 'Passed',
                },
              ]}
              labelDisplay="value"
              tooltip={`Failed: ${stats.totalFailedPostures}, Passed: ${stats.totalPassedPostures}`}
            />
          </div>

          {/* Count Summaries */}
          {/* Unique Policy Count */}
          <InsightItem
            label="Policies *"
            value={stats.uniquePolicyCount}
            tooltip="Policies with findings"
          />
          <InsightItem label="Assets" value={stats.total} />
          <InsightItem
            label="Findings"
            value={stats.totalFailedPostures + stats.totalPassedPostures}
          />
          <InsightItem
            label="Operating Systems"
            value={stats.uniqueOsCount}
            isLast={true}
          />
        </div>
      </Card>
    </div>
  );
};

export default AssetInsights;
